import { betweenTwoPointsDistance, findAngle } from "./FunctionRun/Fun.js";
import { AllMallData, ReadFileAllMallData } from "./FunctionRun/MallData.js";

export let user = {}

export class MapData {
    constructor(id, mallid) {
        this.id = id;
        this.mallid = mallid;
        // this.mapDataPoint = { ...AllMallData[mallid] };
        this.path = [];
        this.selectPointB = null  // This is To
        this.selectPointA = null // This is From 
        this.start = null
        this.end = null
        this.PointType = { elevator: false, escalator: false, stair: false }
        this.currentPathFindingPoint = null


    }
    receveDataPoint = async () => {

        if (AllMallData[this.mallid]) {
            console.log("if blockchain");
            return AllMallData[this.mallid]
        } else {
            // console.log("else blockchain",this.mallid);
            await ReadFileAllMallData(this.mallid)
            // this.mapDataPoint = { ...AllMallData[this.mallid] }
            
            // console.log(AllMallData[this.mallid],"AllMallData[this.mallid]1122");
            return AllMallData[this.mallid]
        }
    }
    findPath = (selectPointA, selectPointB, pointtype) => {  // A is From And B is To 
        this.path = []
        this.StapeByStape = []
        this.start = selectPointA
        this.end = selectPointB
        this.selectPointA = undefined   // this is From 
        this.selectPointB = undefined  // this is to
        this.PointType.elevator = pointtype.elevator
        this.PointType.escalator = pointtype.escalator
        // 
        this.PointType.stair = pointtype.stair
        this.selectPointA = { ...AllMallData[this.mallid].nodePoint[`${selectPointA.x},${selectPointA.y},${selectPointA.z}`] };
        Object.values(AllMallData[this.mallid].nodePoint).forEach((d) => {
            d.point.close = false;
            d.point.previousNode = null;
            d.point.targetDist = Infinity;
            if (
                this.selectPointA.x === d.point.x &&
                this.selectPointA.y === d.point.y &&
                this.selectPointA.z === d.point.z
            ) {
                d.point.targetDist = 0;
            }
        });

        let current = this.selectPointA.point
        this.selectPointB = { ...AllMallData[this.mallid].nodePoint[`${selectPointB.x},${selectPointB.y},${selectPointB.z}`] }
        let visited = []
        let mylocalpoint = undefined;
        let count = 0
        while (current) {
            if (current && this.selectPointB) {
                count++
                if (count > 20) {
                    if (current?.x === this.selectPointA?.x && current?.y === this.selectPointA?.y && current?.z === this.selectPointA?.z) {
                        current = false
                    }
                }
                // debugger
                let lastDistence = this.selectPointB.point;
                if (!mylocalpoint) {
                    visited = [...visited, current];
                }
                let find = this.selectPointB?.point?.LocationName?.text?.toLowerCase()
                let find1 = this.selectPointB?.point?.LocationName?.text?.toLowerCase() == "family washroom"
                let find2 = this.selectPointB?.point?.LocationName?.text?.toLowerCase() == "male washroom"
                let find3 = this.selectPointB?.point?.LocationName?.text?.toLowerCase() == "female washroom"

                if (current.close === false) {
                    current.colleague.forEach((value) => {
                        // 
                        let d = AllMallData[this.mallid].nodePoint[`${value.x},${value.y},${value.z}`].point


                        visited = [...visited, d];
                        let distance = betweenTwoPointsDistance(current, d) + current.targetDist;

                        if (d.targetDist > distance) {
                            d.targetDist = distance;
                            d.previousNode = { x: current.x, y: current.y, z: current.z };
                        }
                        current.close = true;
                        // 
                        if (this.PointType.elevator === true) {

                            if (this.selectPointA.point.z > this.selectPointB.point.z) {
                                // console.log("if");
                                if (d.up) {
                                    // 
                                    d.close = true;

                                }
                            } else {
                                if (d.down) {
                                    // 
                                    d.close = true
                                }
                            }
                            if (d.type === "Elevator") {
                                d.close = true;
                            }
                        }

                        if (this.PointType.escalator === true) {
                            if (d.type === "Escalator") {
                                d.close = true;
                            }
                        }
                        if (this.PointType.stair === true) {
                            if (d.type === "Stair") {
                                d.close = true;
                            }
                        }
                        let visitedData = visited.filter((d) => {
                            if (d.close === false) {
                                return d;
                            }
                        });
                        visited = visitedData;
                    });
                    let minDist = visited.sort((a, b) => a.targetDist - b.targetDist);
                    mylocalpoint = minDist[0];
                    if (mylocalpoint) {
                        if (mylocalpoint?.targetDist > lastDistence?.targetDist) {
                            current = undefined
                            // setcurrentPathFindingPoint(this.selectPointB.point);
                            this.currentPathFindingPoint = { x: this.selectPointB.point.x, y: this.selectPointB.point.y, z: this.selectPointB.point.z }
                        } else {
                            current = mylocalpoint

                        }
                    } else {
                        current = undefined
                        // setcurrentPathFindingPoint(this.selectPointB.point);

                        this.currentPathFindingPoint = {
                            x: this.selectPointB.point.x, y: this.selectPointB.point.y, z: this.selectPointB.point.z
                        }
                        if (find1 || find2 || find3) {
                            // 
                            if (current) {
                                let currnetText = current.LocationName?.text?.toLowerCase()
                                if (currnetText === find) {
                                    // setcurrentPathFindingPoint(current);
                                    this.currentPathFindingPoint = { x: current.x, y: current.y, z: current.z }
                                    current = undefined;
                                }
                            }
                        }
                    }
                    if (find1 || find2 || find3) {
                        // 
                        if (current) {
                            let currnetText = current.LocationName?.text?.toLowerCase()
                            if (currnetText === find) {
                                // setcurrentPathFindingPoint(current);
                                this.currentPathFindingPoint = { x: current.x, y: current.y, z: current.z }
                                current = undefined;
                            }
                        }
                    }
                }
            }
        }
        // console.log(this.currentPathFindingPoint,"currentPathFindingPoint");
        while (this.currentPathFindingPoint) {
            let { x, y, z } = this.currentPathFindingPoint
            this.path = [...this.path, this.currentPathFindingPoint];
            // setcurrentPathFindingPoint(currentPathFindingPoint.previousNode);
            // console.log(AllMallData[this.mallid].nodePoint[`${x},${y},${z}`].point.previousNode);
            this.currentPathFindingPoint = AllMallData[this.mallid].nodePoint[`${x},${y},${z}`].point.previousNode
            // 
        }
        this.path = this.path.reverse();
        let pathLine = [];

        this.path.forEach((d, i) => {
            if (this.path[i + 1]) {
                pathLine = [...pathLine, { a: d, b: this.path[i + 1] }];
            }
        });

        let dir = [];
        let lastPoint = null;
        let nextfloor = false;
        let distNikalo = (a, b) => {
            return betweenTwoPointsDistance(a, b) * AllMallData[this.mallid].DefaultDist;
        }
        let roots = {}
        let floorRoot = {}
        let floorNumber = []
        let stapes = 1
        pathLine.forEach((d, i) => {
            if (d.a.z === d.b.z) {
                if (roots[stapes]) {
                    roots[stapes] = [...roots[stapes], d]
                } else {
                    roots[stapes] = [d]
                }
            } else {
                stapes++;
            }
            if (pathLine[i + 1]) {
                if (d.a.z === pathLine[i + 1].a.z) {
                    let angle = findAngle(d.a, d.b, pathLine[i + 1].a, pathLine[i + 1].b);
                    if (nextfloor === false) {
                        if (angle <= 5 && angle >= -5) {
                        } else if (angle < -5) {
                            if (dir.length === 0) {
                                let dist = distNikalo(pathLine[0].a, d.b);
                                lastPoint = d.b;
                                dir.push({
                                    angle, dist, turn: "left", data: pathLine[i + 1], floor: d.b.z,
                                    type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                                });
                            } else {
                                let dist = distNikalo(lastPoint, d.b);
                                lastPoint = d.b;
                                dir.push({
                                    angle, dist, turn: "left", data: pathLine[i + 1], floor: d.b.z,
                                    type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                                });
                            }
                        } else if (angle > 5) {
                            if (dir.length === 0) {
                                let dist = distNikalo(pathLine[0].a, d.b);
                                lastPoint = d.b;
                                dir.push({
                                    angle, dist, turn: "right", data: pathLine[i + 1], floor: d.b.z,
                                    type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                                });
                            } else {
                                let dist = distNikalo(lastPoint, d.b);
                                lastPoint = d.b;
                                dir.push({
                                    angle, dist, turn: "right", data: pathLine[i + 1], floor: d.b.z,
                                    type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                                });
                            }
                        }
                    } else {
                        if (angle === 0) {
                            let dist = distNikalo(lastPoint, d.b);
                            lastPoint = d.b;
                            dir.push({
                                angle, dist, turn: "sida", data: pathLine[i + 1], floor: d.b.z,
                                type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                            });
                        } else if (angle < 0) {
                            let dist = distNikalo(lastPoint, d.b);
                            lastPoint = d.b;
                            dir.push({
                                angle, dist, turn: "left", data: pathLine[i + 1], floor: d.b.z,
                                type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                            });
                        } else if (angle > 0) {
                            let dist = distNikalo(lastPoint, d.b);
                            lastPoint = d.b;
                            dir.push({
                                angle, dist, turn: "right", data: pathLine[i + 1], floor: d.b.z,
                                type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                            });
                        }
                        nextfloor = false;
                    }
                } else {

                    let dist = distNikalo(d.a, d.b);
                    dir.push({
                        angle: null,
                        dist,
                        turn: d.a.type
                            ? "take " +
                            d.a.type +
                            (d.a.z > d.b.z ? " Down " : " Up " + " To ") + AllMallData[this.mallid]?.FloorImg[d.b.z].FloorName
                            : "Next Floor",
                        data: pathLine[i + 1],
                        next: d.a.z > d.b.z ? "Down" : "Up",
                        floor: d.b.z,
                        type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                    });
                    nextfloor = true;
                    lastPoint = d.b;
                }
            } else {

                if (dir[dir.length - 1]?.data) {
                    let dist = distNikalo(dir[dir.length - 1]?.data?.a, d.b);
                    dir.push({
                        angle: null, dist, done: "ok", floor: d.b.z, data: d,
                        type: AllMallData[this.mallid].nodePoint[`${d.a.x},${d.a.y},${d.a.z}`].point.type
                    });
                }
            }
        });

        Object.values(roots).forEach((d, i) => {
            // if (!floorNumber.includes(d[0].a.z)) {
            //     floorNumber.push(d[0].a.z)
            // }
            if (floorRoot[d[0].a.z]) {
                floorRoot[d[0].a.z].push(d)
                floorNumber.push(d[0].a.z)
            } else {
                floorRoot[d[0].a.z] = [d]
                floorNumber.push(d[0].a.z)

            }
        })

        this.StapeByStape = dir
        let dirwidthtext = dir?.map((d, i) => {
            if (i === 0) {
                return { ...d, text: `Leave your location And Turn ${d.turn}` }
            } else {
                if (dir.length === i + 1) {
                    return { ...d, text: ` Arrive at Your destination` }
                } else {
                    if (d.turn === "right" || d.turn === "left") {
                        return { ...d, text: `Turn ${d.turn}` }
                    } else {
                        if (d.turn === "Next Floor") {
                            return { ...d, text: `Take ${d.type}` }

                        } else {
                            return { ...d, text: `Go Straight ` }

                        }
                    }
                }
            }
        })
        return { path: this.path, StapeByStape: dirwidthtext, pathLine: pathLine, start: this.selectPointA, end: this.selectPointB,roots, floorRoot,floorNumber }
    }
}
